module.exports = __webpack_public_path__ + "img/paint1.64234267.png";